import React from "react";
import { ScaleLoader } from "react-spinners";

const Spinner = ({ loading }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        backgroundColor: "rgb(255, 255, 255)",
        zIndex: 9999,
      }}
    >
      <ScaleLoader color="#000458" loading={loading} size={60} />
    </div>
  );
};

export default Spinner;